import React, { Component } from "react";
import TaskService from '../service/taskService';
import TaskStatusService from '../service/taskStatusService';
import TaskListWithCheckbox from '../components/tasklistWithCheckbox';
import MilestoneService from "../service/MilestoneService";
import NavigationBar from "../components/navigationBar";

class MilestoneDetailSite extends Component {

    constructor(props) {
        super(props);
        this.milestoneService = new MilestoneService();
        this.taskService = new TaskService();
        this.taskStatusService = new TaskStatusService();
        this.state = {
            milestone: null,
            taskStatuses: [],
            tasks: [],
            milestoneTasks: [],
            selectedAddTasks: [],
            selectedRemoveTasks: []
        }

        this.handleAddCheckBoxChange = this.handleAddCheckBoxChange.bind(this);
        this.handleRemoveCheckBoxChange = this.handleRemoveCheckBoxChange.bind(this);
        this.removeTasksFromMilestone = this.removeTasksFromMilestone.bind(this);
        this.addTasksToMilestone = this.addTasksToMilestone.bind(this)
    }

    componentDidMount() {
        this.getMilestoneInformation();
        this.getMilestoneTasks();
        this.getTaskStatuses();
        this.getOpenTasks();
    }

    async getMilestoneInformation() {

        let result = await this.milestoneService.getMilestoneDetailed(this.props.match.params.milestoneUUID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                milestone: result
            })
        }
    }

    async addTasksToMilestone() {
        let result = await this.milestoneService.addTasksToMilestone(this.props.match.params.milestoneUUID, this.state.selectedAddTasks);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.getMilestoneTasks();
        }
    }

    async removeTasksFromMilestone() {

        let result = await this.milestoneService.removeTasksFromMilestone(this.props.match.params.milestoneUUID, this.state.selectedRemoveTasks);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.getMilestoneTasks();
        }

    }

    async getTaskStatuses() {
        let result = await this.taskStatusService.getTaskStatuses();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                taskStatuses: result
            })
        }
    }

    handleAddCheckBoxChange(event, taskUUID) {
        let existsIndex = this.state.selectedAddTasks.indexOf(taskUUID);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.selectedAddTasks;
                array.push(taskUUID);
                this.setState(() => ({ selectedAddTasks: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.selectedAddTasks;
                array.splice(existsIndex, 1);
                this.setState(() => ({ selectedAddTasks: array }))
            }
        }
    }

    handleRemoveCheckBoxChange(event, taskUUID) {
        let existsIndex = this.state.selectedRemoveTasks.indexOf(taskUUID);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.selectedRemoveTasks;
                array.push(taskUUID);
                this.setState(() => ({ selectedRemoveTasks: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.selectedRemoveTasks;
                array.splice(existsIndex, 1);
                this.setState(() => ({ selectedRemoveTasks: array }))
            }
        }
    }

    async getOpenTasks() {
        let result = await this.taskService.retrieveTasks(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tasks: result
            })
        }
    }
    //api/Milestone/Tasks
    async getMilestoneTasks() {
        let result = await this.milestoneService.getTasksInMilestone(this.props.match.params.milestoneUUID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                milestoneTasks: result
            })
        }
    }


    render() {
        const milestone = this.state.milestone;
        if (!milestone) return null;
        const taskStatuses = this.state.taskStatuses;
        if (taskStatuses.length === 0) return null;

        return (
            <div className="body">
                <NavigationBar {...this.props} />
                <main>

                    <p>{milestone.title}</p>
                    <TaskListWithCheckbox tasks={this.state.milestoneTasks} taskStatuses={this.state.taskStatuses} projectUUID={this.props.match.params.projectID} SelectedTasksCallBack={this.handleRemoveCheckBoxChange} />
                    <button onClick={(event) => (this.removeTasksFromMilestone(event))}>Remove tasks from milestone</button>
                    <TaskListWithCheckbox tasks={this.state.tasks} taskStatuses={this.state.taskStatuses} projectUUID={this.props.match.params.projectID} SelectedTasksCallBack={this.handleAddCheckBoxChange} />
                    <button onClick={(event) => (this.addTasksToMilestone(event))}>Add tasks to milestone</button>
                </main>
            </div>
        )
    }
}

export default MilestoneDetailSite;


// WEBPACK FOOTER //
// ./src/sites/MilestoneDetailed.js